import type { ReactNode } from 'react';

export const generateSpanWithDataTestId = (
  title: string | number | null | JSX.Element | ReactNode,
  dataTestId: string
) => {
  return <span data-testid={dataTestId}>{title || ''}</span>;
};
